import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(theme => ({
  root: { width: "100%" },
  buttons: { display: "flex", flexDirection: "column" },
}));
